import { Geolocation } from "@capacitor/geolocation";

export interface GeoPoint {
  lat: number;
  lng: number;
  accuracyM: number | null;
}

// Works in the browser (web geolocation) and in the Capacitor shell (native).
export async function currentPosition(): Promise<GeoPoint | null> {
  try {
    const pos = await Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 10000 });
    return {
      lat: pos.coords.latitude,
      lng: pos.coords.longitude,
      accuracyM: pos.coords.accuracy ?? null,
    };
  } catch {
    return null;
  }
}
